import { UIHeading1, UIText1, UIText2, Button, IconPlus16, IconSecurity16 } from '@cian/ui-kit';
import * as React from 'react';
import { useMobileFilters } from 'shared/hooks/useMobileFilters';

import * as styles from './styles.css';
import { trackAddMyHomeClick } from '../../../containers/StickyScrollBtn/tracking';

interface IHeroBannerMobileProps {
  containerRef?: React.Ref<HTMLDivElement>;
}

export const HeroBannerMobile: React.FC<IHeroBannerMobileProps> = ({ containerRef }) => {
  const { openMobileFiltersModal } = useMobileFilters();

  const handleClick = React.useCallback(() => {
    openMobileFiltersModal();
    trackAddMyHomeClick();
  }, [openMobileFiltersModal]);

  return (
    <div data-testid="HeroBannerMobile" className={styles['container']}>
      <div className={styles['title']}>
        <UIHeading1 as="h1">Мой дом — центр управления вашей недвижимостью</UIHeading1>
      </div>
      <div className={styles['description']}>
        <UIText1>
          Добавляйте квартиры, дома и участки — расскажем всё, что нужно для выгодной продажи, сдачи и поиска нового
          жилья
        </UIText1>
      </div>
      <div ref={containerRef}>
        <Button
          onClick={handleClick}
          theme="fill_primary"
          beforeIcon={<IconPlus16 color="white_100" />}
          fullWidth={true}
          size="L"
        >
          Добавить объект
        </Button>
      </div>
      <div className={styles['security']}>
        <IconSecurity16 />
        <UIText2>Данные в безопасности — никому их не передаём и не спамим</UIText2>
      </div>
    </div>
  );
};

HeroBannerMobile.displayName = 'HeroBannerMobile';
